import React from 'react';
import { sendCustomTrackingInfo } from '@panel/commons';
import styled, { css } from 'styled-components';
import alertCircleIcon from '@panel/commons/assets/icons/AlertCircle.svg';
import blueAlertCircleIcon from '@panel/commons/assets/icons/AlertCircleBlue.svg';
import { selectColor } from '@panel/commons/core';

const Alert = ({
  children,
  isMobile,
  isNeutral,
  buttonText,
  onButtonPress,
  buttonDataPanel,
  dataLayerText,
  optionalButtonText,
  onOptionalButtonPress,
  optionalButtonDataPanel
}) => {
  return (
    <ContentLayout isNeutral={isNeutral} isMobile={isMobile}>
      <div className='labelContainer'>
        <div className='iconContainer' data-panel='panel-modal-alertCircle'>
          <AlertCircle isNeutral={isNeutral} />
        </div>
        <p data-panel='panel-modal-alertMessage'>{children}</p>
      </div>
      <div className='buttonsContainer'>
        {optionalButtonText && (
          <Button
            data-panel={optionalButtonDataPanel || ''}
            isOptional
            isNeutral={isNeutral}
            onClick={() => onOptionalButtonPress()}
            isMobile={isMobile}
          >
            {optionalButtonText}
          </Button>
        )}
        {buttonText && (
          <Button
            data-panel={buttonDataPanel || ''}
            isNeutral={isNeutral}
            onClick={() => {
              onButtonPress();
              sendCustomTrackingInfo(dataLayerText);
            }}
          >
            {buttonText}
          </Button>
        )}
      </div>
    </ContentLayout>
  );
};

const ContentLayout = styled.div`
  background-color: ${selectColor('alertRed')};
  height: fit-content;
  padding: 12px 12px 12px 8px;
  border-radius: 4px;
  border-left: 5px solid ${selectColor('feedbackWrong')};
  color: ${selectColor('feedbackWrong')};
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  .labelContainer {
    align-items: center;
    display: flex;
    white-space: normal;
  }
  .buttonsContainer {
    display: flex;
    justify-content: flex-end;
  }
  ${({ isNeutral }) =>
    isNeutral &&
    css`
      background-color: ${selectColor('grayLight')};
      border-left: 5px solid ${selectColor('blue')};
      color: ${selectColor('black')};
    `}
  ${({ isMobile }) =>
    isMobile &&
    css`
      flex-direction: column;
      p {
        max-width: 93%;
      }
      .labelContainer {
        align-items: baseline;
      }
      .iconContainer {
        position: relative;
        top: 6px;
      }
    `}
`;

const AlertCircle = styled.div`
  background-image: url(${alertCircleIcon});
  width: 16px;
  height: 16px;
  margin-right: 5px;
  margin-bottom: 3px;
  ${({ isNeutral }) =>
    isNeutral &&
    css`
      background-image: url(${blueAlertCircleIcon});
      background-size: cover;
      margin-right: 9px;
    `}
`;

const Button = styled.div`
  cursor: pointer;
  font-weight: 500;
  margin-right: 14px;
  ${({ isNeutral }) =>
    isNeutral &&
    css`
      color: ${selectColor('blue')};
    `}
  ${({ isOptional, isMobile }) =>
    isOptional &&
    css`
      margin-right: ${isMobile ? 10 : 14}px;
    `}
`;

export default Alert;
